import GamePostMessageListenerBase from './game_post_messages_listener_base';

export default class VoidGamePostMessageListener extends GamePostMessageListenerBase {
    static CLASS = 'VoidGamePostMessageListener';

    processPostMessage(messageData) {
        // nothing to do here
    }
}